import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../../service/auth.service';
import { ToastrService } from 'ngx-toastr';

import { PasswordValidator } from '../../../util/password-validator';

@Component({
  selector: 'mc-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

    currentPassword: string = '';
    newPassword: string = '';
    confirmPassword: string = '';

    constructor(
        private router: Router,
        private authService: AuthService,
        private notifService: ToastrService
    ) {}

    ngOnInit() {}

    onCancel() {
        this.notifService.info('Operação cancelada');
    }

    changePassword() {
        let validator = new PasswordValidator(this.currentPassword, this.newPassword, this.confirmPassword);
        if (validator.validate()) {
            this.authService.changePassword(this.currentPassword, this.newPassword, this.confirmPassword).subscribe(
                success => {
                    this.notifService.success('Senha atualizada');
                    this.router.navigate(['home']);
                },
                error => {
                    if (error.hasOwnProperty('current_password') && error.current_password == 'is invalid') {
                        this.notifService.warning('Senha atual inválida');
                    } else {
                        this.notifService.error('Ocorreu um erro na aplicação, favor contactar o administrador');
                    }
                }
            );
        } else {
            this.notifService.warning(validator.message);
        }
    }
}